import { definitions } from './types.blumenau';

export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json }
  | Json[];

export interface Database {
  cadastro: {
    Tables: {
      imobiliario: {
        // definir os possíveis campos do retorno do select
        Row: definitions['imobiliario'];
        // definir os possíveis campos de criação
        Insert: Partial<definitions['imobiliario']>;
        // definir os possíveis campos de atualização
        Update: Partial<definitions['imobiliario']>;
      };
      lote: {
        // definir os possíveis campos do retorno do select
        Row: definitions['lote'];
        // definir os possíveis campos de criação
        Insert: Partial<definitions['lote']>;
        // definir os possíveis campos de atualização
        Update: Partial<definitions['lote']>;
      };
      bairro: {
        // definir os possíveis campos do retorno do select
        Row: definitions['bairro'];
        // definir os possíveis campos de criação
        Insert: Partial<definitions['bairro']>;
        // definir os possíveis campos de atualização
        Update: Partial<definitions['bairro']>;
      };
      pessoa: {
        // definir os possíveis campos do retorno do select
        Row: definitions['pessoa'];
        // definir os possíveis campos de criação
        Insert: Partial<definitions['pessoa']>;
        // definir os possíveis campos de atualização
        Update: Partial<definitions['pessoa']>;
      };
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      aval_imoveis: {
        Args: { inscricao_imobiliaria: string };
        Returns: AvalImoveisFunction;
      };
    };
    Enums: {
      [_ in never]: never;
    };
  };
}

/* CUSTOM TYPES */

// Generated by https://quicktype.io

export interface AvalImoveisFunction {
  id_imobiliario: number;
  id_lote: number;
  id_imobiliario_pessoa: number;
  id_pessoa: number;
  id_bairro: number;
  cadastro: string;
  inscricao_lote: string;
  ativo: string;
  inscricao_cadastral_lote: string;
  inscricao_cadastral_imovel: string;
  ocupacao: string;
  area_terreno: string;
  acumulo_metrico: string;
  testada_principal: string;
  calcada: string;
  limite: string;
  irregularidade: string;
  tipo_insercao: string;
  zona_fiscal: string;
  setor_calculo: string;
  nome: string;
  patrimonio: string;
  situacao: string;
  pedologia: string;
  topografia: string;
  geometria: string;
  quota_inundacao: string;
  inscricao_geo: string;
  unidade: string;
  unidade_avaliacao: string;
  numero_unidades_avaliacao: string;
  pav_numero_total: string;
  cpf_cnpj: string;
  proprietario: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cep: string;
  ano_construcao: string;
  pontuacao: string;
  padrao_acabamento: string;
  tipologia: string;
  tipo_uso: string;
  disposicao: string;
  estado_conservacao: string;
  fracao_ideal: string;
  area_tributavel: string;
  estrutura: string;
  material_predominante: string;
  revestimento_externo: string;
  pintura_externa: string;
  cobertura: string;
  esquadrias: string;
  equacao: number[];
}
